import React, {useState, useEffect} from 'react';
import usePageTitle from "../hooks/usePageTitle";
import {
    ElectedOfficialsSection,
    GeographySection,
    HeroTitle,
    MunicipalCouncilSection,
} from "../components";
import {
    HeroShimmer,
    GeographyShimmer,
    ElectedOfficialsShimmer,
    MunicipalCouncilShimmer
} from "../components/shimmer";
import backgroundImageHome from "../assets/images/background/bg.jpg";

const Township = () => {
    usePageTitle('Les élus');
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        const timer = setTimeout(() => {
            setIsLoading(false);
        }, 2000);

        return () => clearTimeout(timer);
    }, []);

    if (isLoading) {
        return (
            <div className="flex flex-col">
                <HeroShimmer/>
                <GeographyShimmer/>
                <ElectedOfficialsShimmer/>
                <MunicipalCouncilShimmer/>
            </div>
        );
    }

    return (
        <div className="flex flex-col">
            <HeroTitle
                title="Les élus de la Commune Urbaine d'Ambalavao"
                description="Découvrez l'équipe municipale qui œuvre au quotidien pour le développement de notre commune"
                backgroundImage={backgroundImageHome}
            />
            <GeographySection/>
            <ElectedOfficialsSection/>
            <MunicipalCouncilSection/>
        </div>
    );
};

export default Township;